<template>
  <picker-field :label="label" :display="display" :title="title" ref="picker">
    <div class="weui-cells weui-cells_checkbox">
      <label
        class="weui-cell weui-cell_active weui-check__label"
        v-for="item in items"
        :key="item.display"
      >
        <div class="weui-cell__hd">
          <input
            type="checkbox"
            class="weui-check"
            :value="item.value"
            v-model="values"
            @change="onChange"
          />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd">
          <p>{{item.display}}</p>
        </div>
      </label>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: String,
    value: String,
    title: String,
    items: Array
  },
  data() {
    var me = this,
      value = me.value;
    return {
      // value本身是多个值用逗号拼接的字符串
      values: value ? value.split(",") : []
    };
  },
  computed: {
    display() {
      var me = this,
        values = me.values,
        displays = [];
      me.items.forEach(item => {
        if (values.indexOf(item.value) > -1) {
          displays.push(item.display);
        }
      });
      return displays.join(" ");
    }
  },
  watch: {
    value() {
      var me = this,
        value = me.value;
      // 数据加载完成后value才会改变，此时通过value计算出values
      if (!me.parsedValue) {
        me.parsedValue = true;
        me.values = value ? value.split(",") : [];
      }
    },
    $route() {
      this.parsedValue = false;
    }
  },
  methods: {
    clear(){
      this.parsedValue = false;
    },
    onChange() {
      var me = this;
      me.parsedValue = true;
      me.$emit("input", me.values.join(","));
    }
  }
};
</script>